import { CSVLink } from "react-csv";
import { useRef } from "react";

export const DownloadLeadsCSV = ({ list = [] }) => {
  const csvLinkRef = useRef();

  const headers = [
    { label: "First Name", key: "fld_first_name" },
    { label: "Last Name", key: "fld_last_name" },
    { label: "Country", key: "fld_country" },
    { label: "Mobile Number", key: "fld_mobile_number" },
    { label: "Email Address", key: "fld_email_address" },
    { label: "City of Interest", key: "fld_city_of_interest" },
    { label: "Budget", key: "budget" },
    { label: "Property Type", key: "fld_property_type" },
    { label: "Status", key: "fld_leads_status" },
    { label: "Timeline", key: "fld_timeline_to_invest" },
    { label: "Remarks", key: "fld_remarks" },
  ];

  const handleDownload = () => {
    csvLinkRef.current.link.click();
  };

  return (
    <>
      <button type="button" className="visitor-btn" onClick={handleDownload}>
        Download CSV
      </button>

      <CSVLink
        data={list}
        headers={headers}
        filename="leads-report.csv"
        ref={csvLinkRef}
        style={{ display: "none" }}
      />
    </>
  );
};
